import app from 'app';
import Marionette from 'backbone.marionette';

app.namespace.Controller.KeyboardAccessibility = Marionette.Object.extend({
  initialize: function (/* options*/) {
    this.eventNamespace = '.keyboardAccessibility-' + Date.now();
  },

  off: function () {
    $(document).off(this.eventNamespace);
  },

  /**
   * register global keyboard events
   */
  on: function () {
    if (!this.options.enable) {
      return;
    }

    $(document).on(
      'keydown.preventBackspace' + this.eventNamespace,
      this._preventBackspace
    );
  },

  _preventBackspace: function (e) {
    if ($.ui.keyCode.BACKSPACE === e.which && !$(e.target).isEditable()) {
      e.preventDefault();
    }
  },

  /**
   * enable/disable all registered components during runtime
   */
  enable: function (yes) {
    this.options.enable = yes;
  },

  /**
   * remove specific handlers of component
   * @param componentName
   */
  remove: function (componentName) {
    // find handler, set it to null by its index, then compact and reset handlers for key
    this._keyHandlers.forEach(
      function (handlers, key) {
        let removed = false;

        _.each(handlers, function (handler, index) {
          if (handler.componentName === componentName) {
            removed = true;
            handlers[index] = null; // mark for remove by _.compact
          }
        });

        if (removed) {
          const compactHandlers = _.compact(handlers);
          if (_.isEmpty(compactHandlers)) {
            this._keyHandlers.delete(key);
          } else {
            this._keyHandlers.set(key, compactHandlers);
          }
        }
      }.bind(this)
    );
  },

  removeAll: function () {
    this._keyHandlers.clear();
  },

  /**
   * Attach new component where `componentName` is a unique identifier
   * Adding component that is already registered will have no effect (KISS)
   * @param componentName
   * @param handlers {Array} of objects like this
   * {on:<event_name>, key: <int_keyCode>, run:<event_handler>, stash: <optional_data_stash>}
   */
  add: function (componentName, handlers) {
    // TODO: add support for multiple handlers like: keydown SPACE and keyup SPACE
    // TODO: ... like: generateId() -> {return event+key};

    if (!this.options.enable) {
      return;
    }

    this._setComponentGlobalKeyboardHandlers();

    const unique = this.isUnique(componentName);
    if (!unique) {
      app.doctorController.report(
        'Warning in KeyboardAccessibility - registering component "' +
          componentName +
          '" multiple times!'
      );
      return;
    }

    _.each(
      handlers,
      function (handler) {
        // save `componentName` inside handler
        handler.componentName = componentName;

        let registeredKeyHandlers = this._keyHandlers.get(handler.key);
        if (_.isEmpty(registeredKeyHandlers)) {
          registeredKeyHandlers = [];
        }
        registeredKeyHandlers.push(handler);
        this._keyHandlers.set(handler.key, registeredKeyHandlers);
      }.bind(this)
    );
  },

  isUnique: function (componentName) {
    let unique = true;

    // eslint-disable-next-line no-unused-vars
    for (const kvPair of this._keyHandlers) {
      const handlers = kvPair[1];
      if (_.some(handlers, { componentName })) {
        unique = false;
        break;
      }
    }

    return unique;
  },

  _setComponentGlobalKeyboardHandlers: function () {
    if (!this._cgkhIsSet) {
      this._cgkhIsSet = true;
      this._keyHandlers = new Map();

      $(document)
        .on('keydown' + this.eventNamespace, this._componentListener.bind(this))
        .on(
          'keypress' + this.eventNamespace,
          this._componentListener.bind(this)
        )
        .on('keyup' + this.eventNamespace, this._componentListener.bind(this));
    }
  },

  isEditingEvent(e) {
    return $(e.target).isEditable();
  },

  _componentListener: function (e) {
    const key = e.which;
    const handlers = this._keyHandlers.get(key);

    if (!_.isEmpty(handlers)) {
      const topHandler = _.findLast(handlers, (h) => {
        const ctrlKey = !!h.ctrlKey;
        const metaKey = !!h.metaKey;
        const shiftKey = !!h.shiftKey;
        return (
          h.on === e.type &&
          ctrlKey === e.ctrlKey &&
          shiftKey === e.shiftKey &&
          metaKey === e.metaKey
        );
      });
      if (topHandler) {
        try {
          const allowedInsideEditField = topHandler.inEditor;
          const notInEditingField =
            !topHandler.inEditor && !this.isEditingEvent(e);
          const valid = allowedInsideEditField || notInEditingField;
          valid && topHandler.run(e, topHandler.stash);
        } catch (bug) {
          app.doctorController.report(
            (
              'Exception in KeyboardAccessibility component ' +
              '"{0}" on "{1}" key "{2}"'
            ).format(topHandler.componentName, e.type, key),
            bug
          );
        }
      }
    }
  },
});

export default app.namespace.Controller.KeyboardAccessibility;
